<div class="account-information">
  <h5 class="bz-space--stack-m bz-font-weight--semibold">{{ 'ACCOUNT_INFORMATION.PERSONAL_INFORMATION' | translate }}</h5>
  <bzg-input readonly="true" [(ngModel)]="userName">
    {{ 'ACCOUNT_INFORMATION.PRIMARY_EMAIL' | translate }}
  </bzg-input>
    <div class="account-information__password">
        <h5 class="account-information__password__title bz-font-weight--semibold">{{ 'GLOBAL.PASSWORD' | translate }}</h5>
        <p class="account-information__password__description">{{ 'ACCOUNT_INFORMATION.PASSWORD_DESCRIPTION' | translate }}</p>
        <bzg-button-primary (click)="changePassword()">
            {{ 'ACCOUNT_INFORMATION.CHANGE_PASSWORD' | translate }}
        </bzg-button-primary>
        <p class="account-information__password__error" *ngIf="errorSendingEmail">The server may be incorrectly configurated. Please verify your SMTP server settings and try again.</p>
    </div>
</div>
